import React, { useState, useRef, useLayoutEffect } from 'react';
import { Box, Typography } from '@mui/material';

const FittingNickname = ({ nickname }) => {
    const containerRef = useRef(null);
    const [fontSize, setFontSize] = useState(12);

    useLayoutEffect(() => {
        const el = containerRef.current;
        if (!el) return;

        const maxWidth = 130;
        let currentSize = fontSize;

        el.style.fontSize = `${currentSize}px`;

        while (el.scrollWidth > maxWidth && currentSize > 8) {
            currentSize -= 0.5;
            el.style.fontSize = `${currentSize}px`;
        }

        setFontSize(currentSize);
    }, [nickname]);

    return (
        <Box
            sx={{
                marginBottom: '16px',
                border: '2px solid #000000',
                borderRadius: '8px',
                minWidth: '125px',
                maxWidth: '130px',
                paddingY: '8px',
                backgroundColor: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
            }}
        >
            <Typography
                ref={containerRef}
                sx={{
                    fontFamily: 'Poppins',
                    fontWeight: '400',
                    color: '#0C3466',
                    fontSize: `${fontSize}px`,
                    textAlign: 'center',
                }}
            >
                {nickname}
            </Typography>
        </Box>
    );
};

export default FittingNickname;
